import { render } from "./indexDriveDocumentsComponent.vue?vue&type=template&id=6a80c0c6&scoped=true"
import script from "./indexDriveDocumentsComponent.vue?vue&type=script&lang=js"
export * from "./indexDriveDocumentsComponent.vue?vue&type=script&lang=js"

import "./indexDriveDocumentsComponent.vue?vue&type=style&index=0&id=6a80c0c6&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a80c0c6"]])

export default __exports__